export const muted = "#9b9b9b"
export const cardHeader = "#697b8c"
export const cardSubHeader = "#8ca0b3"